export default __webpack_public_path__ + "static/media/litho-demo-restaurant.acfe00c1.jpg";